export default __webpack_public_path__ + "static/media/Sketchpad.56b8cf5d.png";